import { jsx as a } from "react/jsx-runtime";
const e = ({ className: l, width: o = "14", height: r = "14" }) => /* @__PURE__ */ a(
  "svg",
  {
    className: l,
    width: o,
    height: r,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    children: /* @__PURE__ */ a(
      "path",
      {
        d: "M11.098 4.512a.8.8 0 0 0-1.131 0L6.02 8.457 4.698 7.134a.8.8 0 0 0-1.132 1.132l1.89 1.889a.8.8 0 0 0 1.13 0l4.512-4.512a.8.8 0 0 0 0-1.131Zm-.237.701a.355.355 0 0 1-.077.115L6.273 9.84a.356.356 0 0 1-.503 0L3.88 7.95a.356.356 0 0 1 0 .001l1.89 1.89a.356.356 0 0 0 .502 0l4.512-4.512a.356.356 0 0 0 .077-.116Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as default
};
